import React, { Component } from 'react'
// import { Link } from 'react-router-dom';
// import Notifications from './Notifications';
// import Dashboard from './Dashboard';
// import ProjectList from '../projects/ProjectList';
import { connect } from 'react-redux';
import { firestoreConnect, isLoaded } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import MainpageButtons from './MainpageButtons';
import ParticlesContainer from './ParticlesContainer';
import VerifyEmail from '../layout/VerifyEmail';
import M from 'materialize-css';

// const instance = M.Carousel.getInstance(elem);

// import {Modal, Button} from 'react-materialize';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const jumbotronStyle = {
	paddingBottom: '100px',
	paddingTop: '150px',
	boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",
	position: "relative",
	zIndex: "999",
}

const insideStyle = {
	position: "relative",
	// width: "100%",
	// height: "100%",
	zIndex: "999009",
}

class Mainpage extends Component {
	componentDidMount() {
		M.AutoInit();
	}

	render() {

		const { auth, profile } = this.props;

		const loggedin = !!auth.uid;
		const createButton = loggedin ? null : <Link to='signup' key='createbutton' className='btn btn-large white teal-text waves-effect waves-light lighten-1'>CREATE FREE ACCOUNT</Link>
		const buttons = loggedin ? <MainpageButtons /> : null
		if (!isLoaded(profile)) {

		}
		if (!auth.uid) {
			return <Redirect to={'/signin'} />
		} else if (auth.uid && !profile.esign && profile.isLoaded) {
			return <Redirect to={'/mysign'} />
		}

		if (auth.emailVerified) {
			return (
				<div className="grey lighten-5" >

					<div className="card-panel white-text teal lighten-1" style={jumbotronStyle}>
						<ParticlesContainer>
						</ParticlesContainer>
						<div className="container white-text" style={insideStyle}>
							<div className="row">
								<h4>Decentralized NDA Storage for Enterpreneurs and Freelancers in the modern co-creation era</h4>
								<div className="row">
									<div className="col s6 m6">
										<p>Your lifetime legal partner</p>
									</div>


									<div className="col s4 m4 offset-m1">
										{createButton}
									</div>
								</div>
							</div>
						</div>


					</div>

					<div className="mainpage container z-depth-0 ">


						<div className="row">
							{buttons}
						</div>


						<div className="row">
						</div>
					</div >
				</div>

			)
		} else if (auth && !auth.emailVerified) {
			return (
				<VerifyEmail auth={auth} />
			)
		}
	}
};

const mapStateToProps = (state) => {
	return {
		// createCounts: state.firestore.ordered.createCounts,
		auth: state.firebase.auth,
		profile: state.firebase.profile
		// notifications: state.firestore.ordered.notifications
	}
}

export default compose(
	connect(mapStateToProps),
	firestoreConnect(

	),
)(Mainpage);